<template>
    <v-card-text class="pa-3">
        <div class="text-center">
            <v-img
                src="/images/payment-logos/worldremit.png"
                contain
                class="align-self-start mx-auto mb-3"
                height="50"
            />
            <h4 class="title font-weight-bold primary--text mb-5">
                Payment Confirmation
            </h4>
        </div>

        <div class="d-flex justify-space-between">
            <p class="subtitle-1 mb-0">Name</p>
            <p class="subtitle-1 mb-0 font-weight-bold">
                {{ value.full_name }}
            </p>
        </div>

        <div class="d-flex justify-space-between">
            <p class="subtitle-1 mb-0">Country</p>
            <p class="subtitle-1 mb-0 font-weight-bold">
                {{ value.country }}
            </p>
        </div>

        <div class="d-flex justify-space-between">
            <p class="subtitle-1 mb-0">Telephone</p>
            <p class="subtitle-1 mb-0 font-weight-bold">
                {{ value.phone }}
            </p>
        </div>

        <hr class="my-3" />
        <div class="d-flex justify-space-between">
            <p class="subtitle-1 mb-0">Bank Name</p>
            <p class="subtitle-1 mb-0 font-weight-bold">
                {{ value.institution_name }}
            </p>
        </div>

        <div class="d-flex justify-space-between">
            <p class="subtitle-1 mb-0">Account Number</p>
            <p class="subtitle-1 mb-0 font-weight-bold">
                {{ value.account_number }}
            </p>
        </div>

        <hr class="my-3" />

        <div class="d-flex justify-space-between" v-if="value.receive">
            <p class="subtitle-1 mb-0">Rate</p>
            <p class="subtitle-1 mb-0 font-weight-bold">
                1 {{ value.send.currency }} = {{ getExchangeRate(value) }} {{ value.receive.currency }}
            </p>
        </div>

        <div class="d-flex justify-space-between" v-if="value.receive">
            <p class="subtitle-1 mb-0">They Get</p>
            <p class="subtitle-1 mb-0 font-weight-bold">
                {{ value.receive.currency }} {{ formatAmount(value.receive.amount) }}
            </p>
        </div>

        <div class="d-flex justify-space-between" v-if="value.fee">
            <p class="subtitle-1 mb-0">Fees</p>
            <p class="subtitle-1 mb-0 font-weight-bold">
                {{ value.fee.currency }} {{ formatAmount(value.fee.amount) }}
            </p>
        </div>

        <hr class="my-3" />
        <div class="d-flex justify-space-between" v-if="value.send && value.fee">
            <p class="subtitle-1 mb-0">Total</p>
            <p class="subtitle-1 mb-0 font-weight-bold">
                {{ value.send.currency }} {{ total }}
            </p>
        </div>

        <div class="d-flex justify-space-between mt-4">
            <v-btn
                class="text-none py-5 subtitle-1"
                dark
                color="red darken-2"
                @click="$emit('cancel')"
            >
                Cancel
            </v-btn>

            <v-btn
                class="text-none py-5 subtitle-1"
                dark
                color="primary"
                @click="$emit('confirm')"
            >
                Pay
            </v-btn>
          </div>
    </v-card-text>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    computed: {
        total() {
            const {
                send,
                fee,
            } = this.value;

            if (!send || !fee) {
                return null;
            }

            return this.formatAmount(send.amount + fee.amount);
        },
    },
    methods: {
      formatAmount(amount) {
          return amount ? amount.toFixed(2) : null;
      },
      getExchangeRate({ send, receive }) {
          const sendAmount = send ? send.amount : null;
          const receiveAmount = receive ? receive.amount : null;

          if (sendAmount && receiveAmount) {
            return (receiveAmount / sendAmount).toFixed(5);
          }

          return null;
      },
    },
};
</script>
